module.exports = __webpack_public_path__ + "img/hospital.00da0d33.svg";